/* eslint-disable no-shadow */
import { Typography } from '@material-ui/core';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import style from './style';

interface IItemPage {
  id: string;
  position?: number;
  gameData?: any;
  handleDispatchClick?: () => void;
}

const ItemPage: FC<IItemPage> = ({ id, position, gameData, handleDispatchClick }) => {
  const classes = style();

  const history = useHistory();

  return (
    <div
      className={classes.container}
      onClick={() => {
        history.push(`/admin/game/add-page/serious/${position}`);
        sessionStorage.setItem('isEdit', 'true');
        if (handleDispatchClick) {
          handleDispatchClick();
        }
      }}
    >
      <Typography variant="h4" className={classes.title}>
        +
      </Typography>
    </div>
  );
};

export default ItemPage;
